import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseDeleteMutation, IGetDeleteRequest } from '../../interfaces'

const getDeleteTrainingPersonRequirementMutationRequest: IGetDeleteRequest = params => {
  return {
    method: 'delete',
    url: `${config.baseUrl}/TrainingGroups/`,
  }
}

const useDeleteTrainingPersonRequirementMutation: IUseDeleteMutation<void, { trainingGroupId: number; trainingTypeId: number }> = (params, options = {}) => {
  const request = useMemo(() => getDeleteTrainingPersonRequirementMutationRequest(params), [params])

  const deleteTraining = useCallback(
    async (data: { trainingGroupId: number; trainingTypeId: number }) => {
      return axios({
        ...request,
        url: `${request.url}${data.trainingGroupId}/template/${data.trainingTypeId}`,
      }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<void, Error, any>({ mutationFn: deleteTraining, ...options })

  return response
}

export default useDeleteTrainingPersonRequirementMutation
